module.exports = __webpack_public_path__ + "img/palladium@2x.8323210.png";